import React, { useState, useRef, useEffect } from "react";
import { Calendar } from "@hassanmojab/react-modern-calendar-datepicker";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import moment from "jalali-moment";
import { toast } from "react-toastify";

export default function DiscountCodeForm({ onSubmit }) {
  const [amount, setAmount] = useState("");
  const [expireDate, setExpireDate] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const calendarRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(e.target) &&
        inputRef.current &&
        !inputRef.current.contains(e.target)
      ) {
        setIsCalendarOpen(false);
      }
    };

    if (isCalendarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCalendarOpen]);

  const handleSubmit = () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0 || Number(amount)>100) {
      toast.error("لطفاً یک عدد معتبر برای میزان تخفیف وارد کنید.");
      return;
    }

    if (!expireDate) {
      toast.error("لطفاً تاریخ انقضا را انتخاب کنید.");
      return;
    }

    const jalaliDate = `${expireDate.year}/${expireDate.month}/${expireDate.day} 00:00`;
    const miladiMoment = moment.from(jalaliDate, "fa", "jYYYY/jM/jD HH:mm");

    if (!miladiMoment.isValid()) {
      toast.error("تاریخ معتبر نیست.");
      return;
    }

    const finalExpireDate = miladiMoment.toISOString();

    onSubmit({
      amount: Number(amount),
      expireAt: finalExpireDate,
    });

    setAmount("");
    setExpireDate(null);
  };

  const formatDate = (date) => {
    if (!date) return "";
    const pad = (n) => (n < 10 ? `0${n}` : n);
    return `${date.year}/${pad(date.month)}/${pad(date.day)}`;
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto mt-6 relative">
      <h2 className="text-lg font-bold mb-4 text-gray-800">ایجاد کد تخفیف</h2>

      {/* میزان تخفیف */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">میزان تخفیف (%)</label>
        <input
          type="number"
          min="1"
          className="w-full px-4 py-2 border rounded focus:outline-none focus:ring focus:ring-blue-200"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="مثلاً 20"
        />
      </div>

      {/* انتخاب تاریخ انقضا */}
      <div className="mb-4 relative">
        <label className="block text-gray-700 mb-1">تاریخ انقضا (شمسی)</label>
        <input
          ref={inputRef}
          readOnly
          onClick={() => setIsCalendarOpen(true)}
          value={formatDate(expireDate)}
          placeholder="تاریخ را انتخاب کنید"
          className="w-full px-4 py-2 border rounded cursor-pointer text-center bg-white focus:outline-none"
        />

        {isCalendarOpen && (
          <div
            ref={calendarRef}
            className="absolute top-full right-0 z-50 bg-white border rounded-lg shadow-lg mt-2 p-4"
          >
            <div className="flex justify-end">
              <button
                className="text-gray-500 hover:text-red-600 text-xl font-bold mb-2"
                onClick={() => setIsCalendarOpen(false)}
              >
                &times;
              </button>
            </div>
            <Calendar
              value={expireDate}
              onChange={(date) => {
                setExpireDate(date);
                setIsCalendarOpen(false);
              }}
              shouldHighlightWeekends
              locale="fa"
              colorPrimary="#0f62fe"
            />
          </div>
        )}
      </div>

      {/* دکمه ثبت */}
      <button
        onClick={handleSubmit}
        className="w-full bg-[#aadec5] hover:bg-[#89dfb5] text-gray-600 py-2 rounded-lg transition"
      >
        ایجاد کد تخفیف
      </button>
    </div>
  );
}
